<template>
  <a-modal
    title="数据授权"
    :width="800"
    :height="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    :ok-disabled="disableSubmit"
    @cancel="handleCancel"
    cancelText="关闭"
    style="top:20px;"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
  
        <a-form-item label="用户账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input placeholder="请输入用户账号" v-model="model.username" :readOnly="true"/>
        </a-form-item>
        
        <!-- <a-form-item label="区域权限" :required="true"  :labelCol="labelCol"  :wrapperCol="wrapperCol">
          <a-tree-select 
            style="width: 100%"
            v-model="model.treeData"            
            :tree-data="treeData"
            @treeExpand="handlerTreeExpand"
            tree-checkable
            allow-clear
            :show-checked-strategy="SHOW_PARENT"
            placeholder="请选择厂区-区域-楼栋"
            @change="handlerChange"
            @select="handlerSelect"
          />
        </a-form-item> -->

        <a-form-item label="组织权限"  :required="true"   :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-dropdown :trigger="[this.dropTrigger]"  @visibleChange="dropStatus">
        <span style="user-select: none">
        <a-tree 
            checkable
            multiple
            @check="onCheckDepart"
            :selectedKeys="selectedKeys"
            :checkedKeys="checkedKeys"
            :treeData="departTree"
            :checkStrictly="checkStrictly"
            :expandedKeys="iExpandedKeys"
            :autoExpandParent="autoExpandParent"
            @expand="onExpand"/>
          </span>
        </a-dropdown>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>        
<script>
  import { validateDuplicateValue } from '@/utils/util'
  import { defineComponent, ref, watch } from 'vue';
  import { TreeSelect } from 'ant-design-vue';
  const SHOW_PARENT = TreeSelect.SHOW_CHILD /*TreeSelect.SHOW_PARENT*/;  
  import DepartModal from './InspectDepartModal'
  import {queryDepartTreeList, searchByKeywords} from '@/api/api'
  import {httpAction, deleteAction, getAction,putAction} from '@/api/manage'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  
  export default {
    name: "DataModal",
    mixins: [JeecgListMixin],
    components: {
      DepartModal
    },
    data () {
      return {
        visible: false,
        confirmLoading: false,
        confirmDirty: false,
        validatorRules:{
          treeData:[{required: true, message: '请选择楼栋!'}
          ],
          treeDataDepart:[{required: true, message: '请选择组织!'}
          ],
        }, 
        url: {
          add: "/prevent/UserPermission/predataAdd",
          edit: "/prevent/UserPermission/predataEdit",
          tree: "/prevent/customer/treeList",
          treeCheckedData: "/prevent/UserPermission/predatapermissions",
        },
        SHOW_PARENT,
        treeData:[],
        selectedBuildingIds:[],
        model: {
        },  
        allTreeNodes:[],
        iExpandedKeys: [],
        loading: false,
        autoExpandParent: false,
        /* currFlowId: '',
        currFlowName: '', */
        disable: true,
        treeDataDepart: [],
        visible: false,
        departTree: [],
        rightClickSelectedKey: '',
        rightClickSelectedOrgCode: '',
        hiding: true,
        model: {},
        dropTrigger: '',
        depart: {},
        disableSubmit: false,
        checkedKeys: [],
        selectedKeys: [],
        autoIncr: 1,
        currSelected: {},
        allTreeKeys:[],
        checkStrictly: true,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        form:this.$form.createForm(this)
      }
    },
    created () {
      this.initTreeList();
      this.checkedKeys = [];
      this.model.treeData = [];
    },  
    methods: {
      initTreeList(){
        getAction(this.url.tree).then(res=>{
          if(res.success){
            this.treeData = res.result;
          }
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
      },
      edit(id,username){ 
        this.treeCheckedData(id);
        this.model = {id:id,user_id:id,username:username,treeData: this.model.treeData};
              
        this.visible = true;
      },
      handlerTreeExpand(expandedKeys) {
        //console.log('handlerTreeExpand expandedKeys : ',expandedKeys)
      },
      handlerChange(value, label, extra) {
      //  console.log('handlerChange : ',value, label, extra)
        this.model.buildingIds = value.join(",")
      },
      handlerSelect(value, label, extra) {
       // console.log('handlerSelect  : ',value, label, extra)
      },
      handleSubmit () {
        this.model.departIds = this.checkedKeys;
        this.model.userId = this.model.Id;
        console.log('--buildingIds---' + this.model.treeData);
        console.log('---departIds---' + this.model.departIds);
        if(this.model.treeData == "")
        {
           this.$message.warning("请设置区域权限!");
        }
        else if(this.model.departIds == "")
        {
           this.$message.warning("请设置组织权限!");
        }
        else
        {
        httpAction(this.url.edit,this.model,'put').then((res)=>{
          console.log('-----res----' + res.success);
          if(res.success){
            this.$message.success(res.message);
            this.$emit('ok');
          }else{
            this.$message.warning(res.message);
          }
        }).finally(() => {
          this.confirmLoading = false;
          this.close();
        })
        }
      },
      handleCancel () {
        this.close()
      },      
      loadData() {
          this.refresh();
        },
      loadTree() {
          var that = this
          that.departTree = []
          let para = {applicationCode:'prevent'};
          queryDepartTreeList(para).then((res) => {
            if (res.success) {
              //部门全选后，再添加部门，选中数量增多
              this.allTreeKeys = [];
              for (let i = 0; i < res.result.length; i++) {
                let temp = res.result[i]
                that.departTree.push(temp)
                //that.setThisExpandedKeys(temp)
                that.getAllKeys(temp);
                // console.log(temp.id)
              }
              this.loading = false
            }
          })
        },
        setThisExpandedKeys(node) {
          if (node.children && node.children.length > 0) {
            this.iExpandedKeys.push(node.key)
            for (let a = 0; a < node.children.length; a++) {
              this.setThisExpandedKeys(node.children[a])
            }
          }
        },
        refresh() {
          this.loading = true
          this.loadTree()
        },
        onExpand(expandedKeys) {
          console.log('onExpand', expandedKeys)
          this.iExpandedKeys = expandedKeys
          this.autoExpandParent = false
        },
        backFlowList() {
          this.$router.back(-1)
        },
        // 右键点击下拉框改变事件
        dropStatus(visible) {
          if (visible == false) {
            this.dropTrigger = ''
          }
        },
        // 右键下拉关闭下拉框
        closeDrop() {
          this.dropTrigger = ''
        },
        /* addRootNode() {
          this.$refs.nodeModal.add(this.currFlowId, '')
        }, */
        onCheckDepart(checkedKeys, info) {
          this.hiding = false
          //---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------
          if(this.checkStrictly){
            this.checkedKeys = checkedKeys.checked;
          }else{
            this.checkedKeys = checkedKeys
          }
          console.log('---this.checkedKeys-----' + this.checkedKeys);
        },
        treeCheckedData(id) {
          let params = {userId:id,pageNo:1,pageSize:10000000};
          console.log('====params===' + params);
          this.model.treeData = [];
          this.checkedKeys = [];
          getAction(this.url.treeCheckedData,params).then(res=>{
            if(res.success){ 
              let buildingIds = "";
              let departIds = "";
              res.result.records.forEach(item=>{
                if(item.type == 0)
                {
                  buildingIds += item.mainId + ",";
                }
              });
              if(buildingIds != "")
              {
                buildingIds = buildingIds.substring(0,buildingIds.length-1);
                this.model.treeData = buildingIds.split(",");
              }
              res.result.records.forEach(item=>{
                if(item.type == 1)
                {
                  departIds += item.mainId + ",";
                }
              })
              if(departIds != "")
              {
                departIds = departIds.substring(0,departIds.length-1);
                this.checkedKeys = departIds.split(",");
              }          
              
            }
          });
        },
        openSelect() {
          this.$refs.sysDirectiveModal.show()
        },
        getAllNodes(node) {
          this.allTreeNodes.push(node);
          if (node.children && node.children.length > 0) {
            for (let a = 0; a < node.children.length; a++) {
              this.getAllNodes(node.children[a])
            }
          }
        },
        selectDirectiveOk(record) {
          //console.log('选中指令数据', record)
          this.nodeSettingForm.setFieldsValue({directiveCode: record.directiveCode})
          this.currSelected.sysCode = record.sysCode
        },
       //---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------
        expandAll () {
          this.iExpandedKeys = this.allTreeKeys
        },
        closeAll () {
          this.iExpandedKeys = []
        },
        checkALL () {
          this.checkStriccheckStrictlytly = false
          this.checkedKeys = this.allTreeKeys
        },
        cancelCheckALL () {
          //this.checkedKeys = this.defaultCheckedKeys
          this.checkedKeys = []
        },
        getAllKeys(node) {
          // console.log('node',node);
          this.allTreeKeys.push(node.key)
          if (node.children && node.children.length > 0) {
            for (let a = 0; a < node.children.length; a++) {
              this.getAllKeys(node.children[a])
            }
          }
        },
    }
  }
</script>

<style>
</style>
